import type { AccountDocumentRow } from "@/lib/brokerAccounts";
import {
  BOND_DOCUMENT_SOURCES,
  type BondDocumentSource,
} from "@/lib/bondStateModel";

// BRK-S410, BRK-S440 — the Surety account's DOCUMENTS tab: one row of the
// aggregated, server-paged read (`?scope=all`, PMS-S843) in the
// wireframe's words. PMS filters, searches, pages and decides which version
// is the latest; these are only the words.

/** How a row says where it came from (the wireframe's line under the name). */
const ORIGIN_LABELS = {
  signal: "Generated by Signal",
  broker: "Uploaded by broker",
  // A document Signal asked for is still one the broker uploaded.
  signal_request: "Uploaded by broker",
  obligee: "From the obligee",
} as const satisfies Record<BondDocumentSource, string>;

export function documentOriginLabel(source: unknown): string {
  const known = BOND_DOCUMENT_SOURCES.find((s) => s === source);
  return known === undefined ? "Other" : ORIGIN_LABELS[known];
}

/** "V3" for a document Signal generates — those carry versions — and null
 *  (the cell's "—") for an upload, which has none worth reading. */
export function documentVersionLabel(row: AccountDocumentRow): string | null {
  return row.source === "signal" ? `V${String(row.version)}` : null;
}

/** What a row belongs to, in words: "Account" or its SB number. */
export function documentRelatedLabel(row: AccountDocumentRow): string {
  return row.relatedTo === null ? "Account" : row.relatedTo.sbNumber;
}
